import React, { FunctionComponent } from "react";
import { Box, Flex, Text } from "@familyzone/component-library";

const ErrorFallback: FunctionComponent = (): JSX.Element => {
	return (
		<Flex justifyContent={"space-between"}>
			<Box></Box>
			<Box
				display={"inline-block"}
				alignItems={"center"}
				borderRadius="sm"
				p={10}
				px={20}
				backgroundColor="neutrals.20"
				color="accent.orange.500"
				my={30}
			>
				<Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" role="heading" textAlign={"center"}>
					Error loading Courses module. Please contact Support.
				</Text>
			</Box>
			<Box></Box>
		</Flex>
	);
};

export default ErrorFallback;
